import { useEffect } from "react";
import { api } from "@/lib/api";

const inject = (id, fn) => {
  if (document.getElementById(id)) return;
  fn();
};

export const TrackingPixels = () => {
  useEffect(() => {
    api.get("/settings").then((r) => {
      const m = r.data.marketing || {};

      if (m.meta_pixel_id) {
        inject("meta-pixel", () => {
          const s = document.createElement("script");
          s.id = "meta-pixel";
          s.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${m.meta_pixel_id}');fbq('track','PageView');`;
          document.head.appendChild(s);
        });
      }
      if (m.tiktok_pixel_id) {
        inject("tiktok-pixel", () => {
          const s = document.createElement("script");
          s.id = "tiktok-pixel";
          s.innerHTML = `!function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track"];ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.load=function(e){var n=d.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://analytics.tiktok.com/i18n/pixel/events.js?sdkid="+e+"&lib="+t;var a=d.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a)};ttq.load('${m.tiktok_pixel_id}');ttq.page();}(window,document,'ttq');`;
          document.head.appendChild(s);
        });
      }
      if (m.google_tag_id) {
        inject("google-tag", () => {
          const s = document.createElement("script");
          s.id = "google-tag";
          s.async = true;
          s.src = `https://www.googletagmanager.com/gtag/js?id=${m.google_tag_id}`;
          document.head.appendChild(s);
          const inline = document.createElement("script");
          inline.innerHTML = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments)}gtag('js',new Date());gtag('config','${m.google_tag_id}');`;
          document.head.appendChild(inline);
        });
      }
      if (m.snapchat_pixel_id) {
        inject("snapchat-pixel", () => {
          const s = document.createElement("script");
          s.id = "snapchat-pixel";
          s.innerHTML = `(function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function(){a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};a.queue=[];var s='script';var r=t.createElement(s);r.async=!0;r.src=n;var u=t.getElementsByTagName(s)[0];u.parentNode.insertBefore(r,u)})(window,document,'https://sc-static.net/scevent.min.js');snaptr('init','${m.snapchat_pixel_id}',{});snaptr('track','PAGE_VIEW');`;
          document.head.appendChild(s);
        });
      }
    }).catch(() => {});
  }, []);

  return null;
};
